import { Outlet } from "react-router-dom";
import styles from "./unknown-customer-layout.module.scss";

const UnknownCustomerLayout = () => {
  return (
    <div className={styles.layout}>
        <Outlet />
    </div>
  );
}

export default UnknownCustomerLayout;